import Index from './Index.tsx';
import Page from './Page.tsx';
import { HashRouter, Routes, Route } from 'react-router';
import Templates from "./Templates.tsx";
import TemplateStage from "./templates/TemplateStage.tsx";
import "../static/Base.css";


function App() {
  return (
    <>
    <HashRouter>
      <Routes>
        <Route path="/" element={<Index />}/>
        <Route path = "/page2" element = {<Page/>}/>
        <Route path="/templates" element = {<Templates/>}/>
        <Route path="/templates/stage/*" element = {<TemplateStage/>}/>
      </Routes>
    </HashRouter>
    </>
  );
}

export default App;
